import { useTranslation } from "react-i18next";
import { Props, LegalEntityPAsswordStatusOptionValue, LegalEntityPasswordStatusQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const LegalEntityPasswordStatusQuickfilter = <Q extends LegalEntityPasswordStatusQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.le_password";

  const options: QuickFilterOption<LegalEntityPAsswordStatusOptionValue>[] = [
    {
      name: t(`${tRP}.all`),
      value: {},
    },
    {
      name: t(`${tRP}.created_by_me`),
      value: {
        sharedWithMe: false,
      },
    },
    {
      name: t(`${tRP}.shared_with_me`),
      value: {
        sharedWithMe: true,
      },
    },
    {
      name: t(`${tRP}.shared_by_me`),
      value: { sharedByMe: true },
    },
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="lePasswordStatus"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};
